import Repository from "./repository"

export default {
    /**
     * サブドメインチェック処理
     */
    get(subdomain, type = '0') {
        // クエリパラメータを設定
        let params = {
            subdomain_type: type // サブドメイン種別
        }

        // サブドメインが指定されている場合
        if (subdomain) {
            // サブドメインをクエリパラメータに設定する
            params.subdomain_name = subdomain
        }

        return Repository.get("/api/c204-subdomain-check/check", {params: params})
    }
}
